import React from "react";
import { withNamespaces } from "react-i18next";

const CreateEndProcessBadge = (props) => {
  const { t, badgeText, badgeTextDefault, className } = props;
  return (
    <div
      className={className}
      style={{
        minHeight: "42px",
        borderRadius: "23px",
        fontSize: "100%",
        fontWeight: "400",
        justifyContent: "flex-start",
        alignItems: "center",
        display: "flex",
        width: "fit-content",
        padding: "2px 15px",
      }}
    >
      {badgeText ? badgeText : badgeTextDefault}
    </div>
  );
};

export default withNamespaces()(CreateEndProcessBadge);
